import { useQuery } from "@tanstack/react-query";
import { API_GUIDE } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetGuideInfo = <T>(params?: { [key: string]: any }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_GUIDE_INFO, params],
        queryFn: () => API_GUIDE.getGuideInfo<T>({ ...params }),
    });

    return { data, isLoading };
};
